import { useTranslation } from 'react-i18next'
import { CategoryArchive } from '@/components/sections'
import type { Line } from '@/data/products'

const lineOrder: Line[] = [
  'nashi-argan',
  'set',
  'solari-capelli',
  'essential-energy',
  'filler-therapy',
  'blondy-joy',
  'mass-solution',
  'armonia',
  'style',
]

export function CategoryCapelliPage() {
  const { t } = useTranslation('common')
  return (
    <CategoryArchive
      category="capelli"
      lineOrder={lineOrder}
      hero={{
        eyebrow: t('categoryCapelli.hero.eyebrow'),
        title: t('categoryCapelli.hero.title'),
        titleItalic: t('categoryCapelli.hero.titleItalic'),
        intro: t('categoryCapelli.hero.intro'),
        image: '/images/categories/capelli-hero.jpg',
        imageAlt: t('categoryCapelli.hero.imageAlt'),
      }}
      faq={{
        eyebrow: t('categoryCapelli.faq.eyebrow'),
        title: t('categoryCapelli.faq.title'),
        titleItalic: t('categoryCapelli.faq.titleItalic'),
        body: <p>{t('categoryCapelli.faq.body')}</p>,
        closingNumber: t('categoryCapelli.faq.closingNumber'),
        closingNote: (
          <>
            {t('categoryCapelli.faq.closingNoteLine1')}
            <br />
            <span className="text-bruno">{t('categoryCapelli.faq.closingNoteLine2')}</span>
          </>
        ),
      }}
      labels={{
        filterByLine: t('categoryCapelli.archiveLabels.filterByLine'),
        scrollLeft: t('categoryCapelli.archiveLabels.scrollLeft'),
        scrollRight: t('categoryCapelli.archiveLabels.scrollRight'),
        all: t('categoryCapelli.archiveLabels.all'),
        linePrefix: t('categoryCapelli.archiveLabels.linePrefix'),
        productsSuffix: t('categoryCapelli.archiveLabels.productsSuffix'),
        defaultEyebrow: t('categoryCapelli.archiveLabels.defaultEyebrow'),
        defaultFaqEyebrow: t('categoryCapelli.archiveLabels.defaultFaqEyebrow'),
        categoryAriaLabel: t('categoryCapelli.hero.ariaLabel'),
      }}
    />
  )
}
